import { jwtDecrypt, tokenAlive } from '../../shared/jwtHelper'

const state = {
  isAuthenticated: false,
  authData: {
    token: '',
    tokenExp: '',
    email: ''
  },
  token: ''
}

const getters = {
  getIsAuthenticated (state) {
    return state.isAuthenticated
  },
  getAuthData (state) {
    return state.authData
  },
  getIsTokenActive (state) {
    if (!state.authData.tokenExp) {
      return false
    }
    return tokenAlive(state.authData.tokenExp)
  }
}

const mutations = {
  setIsAuthenticated (state, isAuthenticated) {
    state.isAuthenticated = isAuthenticated
  },
  clearCurrentUser (state) {
    const newData = {
      token: '',
      tokenExp: '',
      email: ''
    }
    state.authData = newData
  },
  setTokenData (state, accessToken) {
    localStorage.setItem('access_token', accessToken)
    const jwtDecodedValue = jwtDecrypt(accessToken)
    const newTokenData = {
      token: accessToken,
      tokenExp: jwtDecodedValue.exp,
      userId: jwtDecodedValue.sub
    }
    state.authData = newTokenData
  }
}

const actions = {
  async login ({ commit }, loginData) {
    commit('setTokenData', loginData)
    commit('setIsAuthenticated', true)
  },
  async logout ({ commit, dispatch, getters }) {
    localStorage.removeItem('access_token')
    commit('clearCurrentUser')
    commit('setIsAuthenticated', false)
    sessionStorage.clear()
  }
}

export default {
  namespaced: false,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/authStore.js